import classnames from 'classnames';
import Image from 'next/image';

import unitLeftArrow from 'public/images/unit_left_arrow.svg';
import unitRightArrow from 'public/images/unit_right_arrow.svg';

export const CarouselArrow = ({
  onClick,
  isVisible,
  direction,
  className,
}: {
  onClick: () => void;
  isVisible: boolean;
  direction: 'prev' | 'next';
  className?: string;
}): React.ReactElement => {
  const isPrev = direction === 'prev';
  const defaultPosition = isPrev
    ? 'absolute left-0 top-0 h-full flex items-center px-3 md:px-3.5 xl:px-4 transition-colors z-10'
    : 'absolute right-0 top-0 h-full flex items-center px-3 md:px-3.5 xl:px-4 transition-colors';

  return (
    <button
      onClick={onClick}
      className={classnames(
        defaultPosition,
        { 'opacity-0 pointer-events-none': !isVisible },
        className
      )}
      aria-label={isPrev ? 'Previous' : 'Next'}
    >
      <Image
        src={isPrev ? unitLeftArrow : unitRightArrow}
        alt={isPrev ? 'Previous' : 'Next'}
        width={28}
        height={48}
        className="w-[13px] h-[28px] md:w-[28px] md:h-[48px]"
        priority
      />
    </button>
  );
};
